import { FEED_BACKED_EDIT_VEHICLE_EXCLUDED_DISPLAY_FIELDS } from '@/constants/vehicleFieldConfig'

export type FeedBackedPricingCapabilityParams = {
  hasLoaded: boolean
  pricingHubEnabled: boolean
  loadError?: boolean
}

export const FEED_BACKED_PRICE_FIELDS = ['price', 'display_price'] as const

export function isFeedBackedPriceField(field: string): boolean {
  return field === 'price' || field === 'display_price'
}

export function iseOwnsLegacyPriceEditing(
  params: FeedBackedPricingCapabilityParams,
): boolean {
  const pricingCapabilitiesResolved =
    params.hasLoaded === true && params.loadError !== true
  return pricingCapabilitiesResolved && params.pricingHubEnabled === false
}

export function pricingHubOwnsFeedBackedPrice(
  params: FeedBackedPricingCapabilityParams,
): boolean {
  return !iseOwnsLegacyPriceEditing(params)
}

export function buildFeedBackedHiddenFieldIds(
  params: FeedBackedPricingCapabilityParams,
): Set<string> {
  const hidden = new Set<string>(FEED_BACKED_EDIT_VEHICLE_EXCLUDED_DISPLAY_FIELDS)
  hidden.add('vehicle_highlights')

  if (iseOwnsLegacyPriceEditing(params)) {
    hidden.delete('price')
    hidden.delete('display_price')
  }

  return hidden
}
